import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };

    return (
        <div className="header-carousel bg-dark">
            <Slider {...settings}>
                <div className="header-carousel-item hero-section">
                    <div className="hero-bg-half-1"></div>
                    <div className="carousel-caption">
                        <div className="container">
                            <div className="row g-4 align-items-center">
                                <div className="col-lg-7 animated fadeInLeft">
                                    <div className="text-sm-center text-md-start">
                                        <h4 className="text-primary text-uppercase fw-bold mb-4">Meet Chris Bumstead</h4>
                                        <h1 className="display-1 text-white mb-4">The Reigning Mr. Olympia Classic Physique Champion</h1>
                                        <p className="mb-5 fs-5">Chris Bumstead is an elite bodybuilder known for his classic aesthetics and dedication to the sport.</p>
                                        <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                                            <a className="btn btn-dark py-3 px-4 px-md-5 me-2" href="#">
                                                <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                                            </a>
                                            <a className="btn btn-primary py-3 px-4 px-md-5 ms-2" href="#"><span>Learn More</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="header-carousel-item hero-section">
                    <div className="hero-bg-half-2"></div>
                    <div className="carousel-caption">
                        <div className="container">
                            <div className="row g-4 align-items-center">
                                <div className="col-lg-7 animated fadeInLeft">
                                    <div className="text-sm-center text-md-start">
                                        <h4 className="text-primary text-uppercase fw-bold mb-4">Meet Dana Linn Bailey</h4>
                                        <h1 className="display-2 text-white mb-4">First-Ever Women's Physique Olympia Champion</h1>
                                        <p className="mb-5 fs-5">Dana is a fitness icon, coach, and entrepreneur inspiring millions with her strength and mindset.</p>
                                        <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                                            <a className="btn btn-dark py-3 px-4 px-md-5 me-2" href="#">
                                                <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                                            </a>
                                            <a className="btn btn-primary py-3 px-4 px-md-5 ms-2" href="#"><span>Learn More</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>
        </div>
    );
};

// Next & Previous Arrow Components
const SampleNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="slick-arrow slick-next"
            style={{ right: "15px", zIndex: 10, cursor: "pointer" }}
            onClick={onClick}
        />
    );
};

const SamplePrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="slick-arrow slick-prev"
            style={{ left: "15px", zIndex: 10, cursor: "pointer" }}
            onClick={onClick}
        />
    );
};

export default Carousel;
